<template>
  <div class="outer">
    <div class="middle">
      <div class="center">

        <div class="frame ">
          <div class="innerframe extrapadding">
            <div v-html="$parent.language[this.gameName].body"></div>
          </div>
          <div>
            <div v-bind:class="{ green: questionok, red: questionwrong }" class="container encpanel ">

              <div class="row">
                <div class="field encryptionLetter" hidden>
                  <input class="input" value="" disabled />
                </div>
                <div v-for="(answer, key, index) in   $parent.language[this.gameName].answers  "
                  class="field encryptionLetter visible-input">
                  <input class="input encBorder" style="text-transform: uppercase;" placeholder="?"
                    maxlength="1" v-model="gameAnswers[index]" :data-answer-index="index" />
                </div>
                <!-- v-on:keyup="this.$refs.secondbox.focus(); this.$refs.secondbox.select(); makeUpper(0);" -->

                <div class="">
                  <button class="button" type="submit" style="border-color:#f29412; border-style: solid;"
                    :style="{ 'background-color': $parent.buttonColor }" @click="checkcode()">{{
                      $parent.language[this.gameName].check }}</button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<style>
@import '../assets/form.css';
</style>

<script>
import { callApi } from '../plugins/callApi.js'

export default {
  name: 'encryptionGame',
  props: {
    msg: String,
    dbid: String,
    gameName: String
  },
  async mounted() {
    this.$emit('pauseTimer', 0)
    this.numberofAnswers = Object.keys(this.$parent.language[this.gameName].answers).length

    // Wait for DOM to be ready
    this.$nextTick(() => {
      this.setupInputNavigation();
    });

    document.querySelector("#app > div.outer > div > div > div").style.borderColor = this.$parent.gameSettings.containerColor
    var setup = await callApi("updateprogress", this.license, { "gameName": this.gameName, "dbid": this.dbid })
    this.$emit('pauseTimer', 0)

    // Generate random numbers for encryption visible letters
    while (this.randNumber.length != this.$parent.gameSettings.encryptionVisibleLetters) {
      var randomnumber = Math.ceil(Math.random() * 5)
      if (this.randNumber.indexOf(randomnumber) === -1) {
        this.randNumber.push(randomnumber)
      }
    }
  },
  data() {
    return {
      letter1: "",
      letter2: "",
      letter3: "",
      letter4: "",
      letter5: "",
      letter6: "",
      questionok: false,
      questionwrong: false,
      randNumber: [],
      gameAnswers: [
      ],
      numberofAnswers: 0
    }
  },
  methods: {
    setupInputNavigation() {
      this.$nextTick(() => {
        // Target only the visible inputs from our v-for loop
        const inputs = document.querySelectorAll('.visible-input input');
        
        inputs.forEach((el, index) => {
          // Clear the input first
          el.value = '';
          this.gameAnswers[index] = '';
          
          el.addEventListener('keydown', (e) => this.handleKeyDown(e, index));
        });
        
        // Focus first input
        if (inputs.length > 0) {
          inputs[0].focus();
        }
      });
    },

    handleKeyDown(e, currentIndex) {
      const key = e.key;
      const input = e.target;

      // Handle letters
      if (/^[a-zA-Z]$/.test(key)) {
        e.preventDefault();
        const upperKey = key.toUpperCase();
        
        // Set the value directly
        input.value = upperKey;
        this.gameAnswers[currentIndex] = upperKey;

        // Move to next input
        if (currentIndex < this.numberofAnswers - 1) {
          const allInputs = document.querySelectorAll('.visible-input input');
          const nextInput = allInputs[currentIndex + 1];
          if (nextInput) {
            nextInput.focus();
          }
        }
        return;
      }

    if (this.$parent?.gameSettings?.encryptionNumbers) {
      if (/^[0-9]$/.test(key)) {
        e.preventDefault();
        
        // Set the value directly
        input.value = key;
        this.gameAnswers[currentIndex] = key;

        // Move to next input
        if (currentIndex < this.numberofAnswers - 1) {
          const allInputs = document.querySelectorAll('.visible-input input');
          const nextInput = allInputs[currentIndex + 1];
          if (nextInput) {
            nextInput.focus();
          }
        }
        return;
      }
    }

      // Handle backspace
      if (key === 'Backspace') {
        e.preventDefault();
        
        if (input.value) {
          // Clear current input
          input.value = '';
          this.gameAnswers[currentIndex] = '';
        } else if (currentIndex > 0) {
          // Move to previous and focus
          const allInputs = document.querySelectorAll('.visible-input input');
          const prevInput = allInputs[currentIndex - 1];
          if (prevInput) {
            prevInput.focus();
          }
        }
        return;
      }

      // Handle arrow keys
      if (key === 'ArrowLeft' && currentIndex > 0) {
        e.preventDefault();
        const allInputs = document.querySelectorAll('.visible-input input');
        const prevInput = allInputs[currentIndex - 1];
        if (prevInput) prevInput.focus();
        return;
      }

      if (key === 'ArrowRight' && currentIndex < this.numberofAnswers - 1) {
        e.preventDefault();
        const allInputs = document.querySelectorAll('.visible-input input');
        const nextInput = allInputs[currentIndex + 1];
        if (nextInput) nextInput.focus();
        return;
      }

      // Block all other keys except essential navigation
      if (!['Tab'].includes(key)) {
        e.preventDefault();
      }
    },

    async checkcode() {
      var correct = 0;
      for (var i = 0; i < this.numberofAnswers; i++) {
        if (this.$parent.language[this.gameName].answers["clue" + i].toUpperCase() == this.gameAnswers[i]) {
          correct++
        }
      }

      if (this.numberofAnswers == correct) {
        this.questionwrong = false
        this.questionok = true
        var setup = callApi("updateprogress", this.license, { "gameName": this.gameName + "End", "dbid": this.dbid })
        this.$emit('updatestage', "")
      } else {
        var setup = callApi("incorrectattempt", this.license, { "gameName": this.gameName, "dbid": this.dbid })
        this.questionwrong = true
        this.$emit('incorrectAttempt')
      }
    }
  }
}
</script>